<template>
  <div>
    <hr />
    <b-tabs content-class="mt-3">
    </b-tabs>
  </div>
</template>

<script>
import api from "@/api";
import { createHelpers } from 'vuex-map-fields';
import TablaBase from "../common/TablaBase.vue";
import CardDetalleLicencia from './CardDetalleLicencia.vue';
import axios from "axios";

const { mapFields } = createHelpers({
  getterType: 'SolicitudAltaModule/getSolicitudAltaField'
});

export default {
  name: "DetalleSolicitudAltaMedica",
  props: {
  },
  watch: {
  },
  components: {
    TablaBase, CardDetalleLicencia
  },
  computed: {
    ...mapFields({
      solicitudSeleccionada: 'selected'
    }),
  },
  data() {
    return {
      cdn_file_url: process.env.CDN_FILE_URL
    };
  },
  methods: {
    agregarAdjunto(item) {
      this.$router.push({ name: 'agregaradjunto', params: { solicitud: item } });
    },
    descargarConstancia(id) {
      this.disabled = true;

      axios({
        url: api.url + "/LicenciaCargoPersonal/GetConstancia/" + id,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        //link.setAttribute('download', 'constancia.pdf');
        link.setAttribute("download", "constancia.docx");
        document.body.appendChild(link);
        link.click();

        this.disabled = false;
      });
    },
    emitirConstancia(id) {
      axios({
        url: api.url + "/LicenciaCargoPersonal/GetConstanciaPdf/" + id,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        console.log('response', response);
        var blob = new Blob([response.data], {type: 'application/pdf'});
        var blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      });
    },
    emitirConstanciaAlta(id) {
      axios({
        url: api.url + "/LicenciaCargoPersonal/GetConstanciaAltaPdf/" + id,
        method: "GET",
        responseType: "blob"
      }).then(response => {
        console.log('response', response);
        var blob = new Blob([response.data], {type: 'application/pdf'});
        var blobURL = URL.createObjectURL(blob);
        window.open(blobURL);
      });
    },
  },
  mounted(){
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/DetalleSolicitudAltaMedica.vue